(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lb-community-newsletter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lb-community-signup')) {
  customElements.define('lb-community-signup', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const get = (key) => { try { return localStorage.getItem(key); } catch { return null; } };
      const set = (key, value) => { try { localStorage.setItem(key, value); } catch {} };
      let pending;
      try { pending = JSON.parse(sessionStorage.getItem('lb-newsletter-pending') || 'null'); } catch {}
      const ownResult = pending && pending.id === this.dataset.formId && Date.now() - pending.time < 1800000;
      const success = this.querySelector('[data-lb-success]');
      if (success) {
        set('lb-newsletter-subscribed', 'true');
        window.dispatchEvent(new Event('lb:newsletter-subscribed'));
      }
      this.querySelector('form')?.addEventListener('submit', () => {
        try { sessionStorage.setItem('lb-newsletter-pending', JSON.stringify({ id: this.dataset.formId, time: Date.now() })); } catch {}
      }, { signal });
      if (this.dataset.mode !== 'popup') return;
      const dialog = this.querySelector('dialog');
      let timer;
      const rememberDismissal = () => set('lb-newsletter-dismissed-until', String(Date.now() + Number(this.dataset.expiry) * 86400000));
      const close = () => { rememberDismissal(); dialog.close(); };
      this.querySelectorAll('[data-lb-close]').forEach(button => button.addEventListener('click', close, { signal }));
      dialog.addEventListener('cancel', rememberDismissal, { signal });
      dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } }, { signal });
      const show = () => {
        if (!this.isConnected || dialog.open) return;
        if (!ownResult && this.dataset.designMode !== 'true') {
          if (this.dataset.subscriber === 'true' || get('lb-newsletter-subscribed') === 'true' || Number(get('lb-newsletter-dismissed-until')) > Date.now()) return;
          if (document.querySelector('dialog[open], [aria-modal="true"]:not([aria-hidden="true"]), .modal[aria-hidden="false"]') || /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || '')) {
            timer = setTimeout(show, 3000); this.timer = timer; return;
          }
        }
        if (document.visibilityState === 'hidden') { timer = setTimeout(show, 3000); this.timer = timer; return; }
        dialog.showModal();
      };
      window.addEventListener('lb:newsletter-subscribed', () => { if (!ownResult) { clearTimeout(this.timer); if (dialog.open) dialog.close(); } }, { signal });
      if (ownResult && (success || this.querySelector('[data-lb-error]'))) {
        show();
        try { sessionStorage.removeItem('lb-newsletter-pending'); } catch {}
      } else if (!success && !/\/cart|\/challenge|\/account|\/checkouts/.test(location.pathname)) {
        let views = 1;
        try { views = Number(sessionStorage.getItem('lb-newsletter-views') || 0) + 1; sessionStorage.setItem('lb-newsletter-views', String(views)); } catch {}
        const wait = this.dataset.designMode === 'true' ? 300 : (views >= 2 ? 4000 : Number(this.dataset.delay) * 1000);
        this.timer = setTimeout(show, wait);
      }
      document.addEventListener('shopify:section:select', event => { if (event.target.contains(this)) show(); }, { signal });
    }
    disconnectedCallback() { this.abort?.abort(); clearTimeout(this.timer); this.initialized = false; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
